import React from 'react';
import * as Icons from '@mui/icons-material';
import imgPlaceholderSrc from 'src/assets/img-placeholder-30.png';

const placeholderImg = <img className="image-placeholder" alt="placeholder" src={imgPlaceholderSrc} />;

export default function iconTransform(iconName, styles, biggerIcon = false) {
  if (!iconName) {
    return placeholderImg;
  }
  let svgName = iconName.replace(/[-_]([a-z])/g, (_, char) => char.toUpperCase());
  svgName = svgName.charAt(0).toUpperCase() + svgName.slice(1);
  const Icon = Icons[`${svgName}TwoTone`];
  let style = { fontSize: 30 };
  if (biggerIcon === true) {
    style.fontSize = style.fontSize * 2;
  }
  if (styles) {
    style = {
      ...style,
      ...styles,
    };
  }
  return Icon ? <Icon style={style} /> : placeholderImg;
}
